export default __webpack_public_path__ + "static/media/ancra.f4abcb14.png";